module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hres96u"
    }
  }, [_c('hrms-search-box-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.indexDisp),
      expression: "indexDisp"
    }],
    attrs: {
      "data": _vm.index,
      "nowLang": _vm.dash.nowLang,
      "columns": _vm.columns[_vm.dash.nowLang].index,
      "receivedStore": _vm.receivedHres96uIndex,
      "searchBoxAlias": "approve",
      "maxRowspan": _vm.maxRowspan.index,
      "detailEvent": _vm.detailEvent,
      "approveEvent": _vm.postHres96uSendApprove
    }
  }), _vm._v(" "), _c('detail', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.detailDisp),
      expression: "detailDisp"
    }],
    attrs: {
      "labelsButton": _vm.dash.button[_vm.dash.nowLang],
      "labels": _vm.labels[_vm.dash.nowLang],
      "detail": _vm.detail,
      "toggle": _vm.toggle,
      "nowLang": _vm.dash.nowLang
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-377ac947!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres96u/component.vue
// module id = 3681
// module chunks = 1